/*
 * Liste intégrale des événements
 * utiliser ce store pour lire / modifier / supprimer tout événement
 */

import {callAPI, getTodayDate} from '@/helpers.js';

export default {

    namespaced: true,

    state: {
        events: [],
        highlightedId:-1,

        // Types d'événements distincts
        types: []
    },

    getters: {
        typesOptions (state) {
            return state.types.map( type => {
                return {
                    value: type,
                    label: type
                };
            });
        }
    },

    mutations: {
        setEvents (state, events) {
            state.events = [ ...events ];
        },

        // Met à jour ou ajoute un event au store
        // A appeler après toute mise à jour sur le serveur
        setEvent (state, event) {
            const index = state.events.findIndex(e => e.id == event.id);
            if (index >= 0) {
                state.events.splice(index, 1, { ...event });
            } else {
                state.events.push({ ...event });
            }
        },

        // Retire un event du store
        unsetEvent (state, eventId) {
            const index = state.events.findIndex(e => e.id == eventId);
            if (index >= 0) {
                state.events.splice(index, 1);
            }
        },

        setTypes (state, types) {
            state.types = [ ...types ];
        },

        // Met en surbrillance une ligne
        setHighlightedId (state, id) {
            state.highlightedId = id;
        },
        // Désactive la surbrillance
        resetHighlightedId (state) {
            state.highlightedId = -1;
        }
    },

    actions: {
        // Hydration complète, à appeler au chargement de l'app
        loadFromDatabase (context) {
            callAPI(context, 'Events/getAll', {}, {noOverlay: true})
            .then( response => {
                if (response.status === true) {
                    context.commit('setEvents', response.events);
                }
            });
        },

        // Hydration ou mise à jour de la liste des types d'événements distincts
        loadTypesFromDatabase (context) {
            callAPI(context, 'Main/getEventsTypesSuggestions', {}, {noOverlay: true})
            .then( response => {
                if (response.status === true) {
                    context.commit('setTypes', response.suggestions);
                    context.commit('pages/fixEventsPagesFilters', response.suggestions, {root:true});
                }
            });
        },

        // Retourne un event hydraté ou un event vierge si n'existe pas
        get (context, eventId) {
            const index = context.state.events.findIndex(e => e.id == eventId);
            let event;
            if (index >= 0) {
                event = context.state.events[index];
            } else {
                event = {
                    id: -1,
                    customerId: -1,
                    type: '',
                    date: getTodayDate(),
                    description: '',
                    attachmentsIds: [],
                    usersIds: [context.rootState.session.session.userId]
                };
            }
            return { ...event };
        },

        // Création ou mise à jour d'un event
        // Sauvegarde en DB puis mise à jour du store
        save (context, event) {
            return new Promise( (resolve, reject) => {
                callAPI(context, 'Events/save', {event: { ...event }}, {}).then( response => {
                    if (response.status === true) {
                        context.commit('setEvent', response.event);

                        // Mise à jour des types d'events
                        context.dispatch('loadTypesFromDatabase');

                        // Mise en surbrillance pendant quelques secondes
                        context.commit('setHighlightedId', response.event.id);
                        context.commit('customers/setHighlightedId', response.event.customerId, {root:true});
                        setTimeout(() => {
                            context.commit('resetHighlightedId');
                            context.commit('customers/resetHighlightedId', null, {root:true});
                        }, 500);

                        resolve();
                    } else {
                        reject(response.errors);
                    }
                });
            });
        },


        // Suppression d'un event sur le serveur puis dans le store
        delete (context, eventId) {
            return new Promise( (resolve, reject) => {
                callAPI(context, 'Events/delete', {eventId}, {})
                .then( response => {
                    if (response.status === true) {
                        context.commit('unsetEvent', eventId);

                        // Mise à jour des types d'events
                        context.dispatch('loadTypesFromDatabase');

                        resolve();
                    }
                });
            });
        }
    }
};
